module.exports = __webpack_public_path__ + "00a22681177b425821b4968162350a1b.svg";